import React, { useState, useEffect } from "react"

export default function Dialog({ open, children, zIndex }) {
  return (
    <div
      css={`
        display: ${open ? "block" : "none"};
        background: rgba(119, 119, 119, 0.7);
        padding: 10px;
        /* padding-top:60px; */
        position: fixed;
        overflow-y: scroll;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: ${zIndex || 999};
      `}
    >
      <div
        css={`
        background:white;
        padding:20px;
        margin:20px;
        border:1px solid rgba(0,0,0,0.5);
        box-sizing:border-box:;
        box-shadow:1px 3px 10px 2px grey
        `}
        >
        {children}
      </div>
    </div>
  )
}
